module.exports = __webpack_public_path__ + "assets/btc-orange.3ea0272f.svg";